import type { ReactNode } from "react"
import React from "react"

import type { StackProps } from "@chakra-ui/react"
import { Heading, Stack, Wrap } from "@chakra-ui/react"

import { BackButton } from "@supliful/common"

type Props = Omit<StackProps, "title"> & {
  title: ReactNode
  includeBackButton?: boolean
  backButtonFallbackRoute?: string
  actions?: ReactNode
  children?: ReactNode
}

export const PageHeader = ({
  title,
  includeBackButton,
  backButtonFallbackRoute,
  actions,
  children,
  ...rest
}: Props) => {
  return (
    <Stack width="full" mt={6} mb={{ base: 5, md: 7 }} {...rest}>
      <Stack direction={{ base: "column", md: "row" }}>
        {includeBackButton && (
          <BackButton
            fallbackRoute={backButtonFallbackRoute}
            pl={0}
            height="auto"
          />
        )}

        {actions && (
          <Wrap
            shouldWrapChildren
            direction={{ base: "column", md: "row" }}
            justify="flex-end"
            alignItems={{ base: "flex-start", md: "center" }}
            width="full"
            spacing={5}
          >
            {actions}
          </Wrap>
        )}
      </Stack>

      <Stack
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        alignItems={{ base: "flex-start", md: "center" }}
        width="full"
        spacing={5}
      >
        <Heading width="full" as="h1" size="h4">
          {title}
        </Heading>

        {children}
      </Stack>
    </Stack>
  )
}
